import { shouldUseKitchenInstallWizard } from '@/utils/kitchenInstallWizard';
import { hasKitchenPushOptOut, setKitchenPushOptOut } from '@/utils/kitchenPwaInstall';

const PROMPT_SKIPPED_KEY = 'ollaa_kitchen_push_prompt_skipped';

export const getKitchenNotificationPermission = () => {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission;
};

export const isKitchenPushPromptSkipped = () => {
  try {
    return localStorage.getItem(PROMPT_SKIPPED_KEY) === '1';
  } catch {
    return false;
  }
};

export const markKitchenPushPromptSkipped = () => {
  try {
    localStorage.setItem(PROMPT_SKIPPED_KEY, '1');
  } catch {
    // ignore
  }
};

export const clearKitchenPushPromptSkipped = () => {
  try {
    localStorage.removeItem(PROMPT_SKIPPED_KEY);
  } catch {
    // ignore
  }
};

/** Installierte Küchen-App: Push-Screen vor der PIN (nicht im Safari-Einrichtungs-Wizard). */
export const needsKitchenPushPrompt = () => {
  if (shouldUseKitchenInstallWizard()) return false;
  if (hasKitchenPushOptOut()) return false;
  if (isKitchenPushPromptSkipped()) return false;
  if (getKitchenNotificationPermission() === 'granted') return false;
  return getKitchenNotificationPermission() === 'default'
    || getKitchenNotificationPermission() === 'denied';
};

export const prepareKitchenPushRetry = () => {
  setKitchenPushOptOut(false);
  clearKitchenPushPromptSkipped();
};
